const pageNameKey = "unitInputAndPopover";

export const unitInputAndPopoverEn = {
  [pageNameKey]: {
    labelText: "Unit",
    placeholderText: "Select unit of measure",
  },
};

export const unitInputAndPopoverPtBr = {
  [pageNameKey]: {
    labelText: "Unidade",
    placeholderText: "Selecione a unidade de medida",
  },
};

export const unitInputAndPopoverDe = {
  [pageNameKey]: {
    labelText: "Einheit",
    placeholderText: "Wählen Sie die Maßeinheit aus",
  },
};

export const unitInputAndPopoverZhHans = {
  [pageNameKey]: {
    labelText: "单位",
    placeholderText: "选择计量单位",
  },
};

export const unitInputAndPopoverIt = {
  [pageNameKey]: {
    labelText: "unità",
    placeholderText: "Seleziona unità di misura",
  },
};

export const unitInputAndPopoverEs = {
  [pageNameKey]: {
    labelText: "Unidad",
    placeholderText: "Selecciona la unidad de medida",
  },
};

export const unitInputAndPopoverNl = {
  [pageNameKey]: {
    labelText: "Eenheid",
    placeholderText: "Selecteer de meeteenheid",
  },
};

export const unitInputAndPopoverTr = {
  [pageNameKey]: {
    labelText: "Birim",
    placeholderText: "Ölçü birimini seçin",
  },
};
